<template>
  <component class="fixed inset-x-0 z-50" :is="component" :menu="menu">
    <template v-slot:logo><slot name="logo"></slot></template>
    <template v-slot:icons><slot name="icons"></slot></template>
  </component>
</template>
<script>
import TheNavBarMobile from './TheNavBarMobile.vue'
import TheNavBarDesktop from './TheNavBarDesktop.vue'

export default {
  data () {
    return {
      menu: jsonFromPage('#data-navbar-menu'),
    }
  },

  computed: {
    component() {
      return this.$mq.lg ? TheNavBarDesktop : TheNavBarMobile
    }
  }
}
</script>
